var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"suaw-alert",class:'suaw-alert--' + _vm.type},[_c('Icon',{key:_vm.alertIcon.toString(),staticClass:"suaw-alert__icon",attrs:{"icon":_vm.alertIcon}}),_c('strong',{staticClass:"suaw-alert__text"},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }